import { Route } from 'react-router-dom';
import type { RouteProps } from 'react-router';
import { TRoutesWithChildren, TMicroAppDetailsWithChildren } from '../types';

export const renderRoutes = (routes: TRoutesWithChildren, type: keyof TRoutesWithChildren) =>
  routes[type].map(({ path, element, children }: RouteProps & TMicroAppDetailsWithChildren) =>
    children ? (
      <Route key={path} path={path} element={element}>
        {renderRoutes(children as TRoutesWithChildren, type)}
      </Route>
    ) : (
      <Route key={path} path={path} element={element} />
    )
  );
